import { LOADED, LOADING } from '../../../shared/constants/readyStates';
import { getCompanies } from '../../../services/companies';
import { getUsersPending, activateUser } from '../../../services/users';

export const RETRIEVED_COMPANIES = 'USERS.RETRIEVED_COMPANIES';
export const ERROR_RETRIEVING_COMPANIES = 'USERS.ERROR_RETRIEVING_COMPANIES';
export const FETCH_COMPANIES = 'USERS.FETCH_COMPANIES';
export const SUCCESS = 'USERS.SUCCESS';
export const RETRIEVED_USERS = 'USERS.RETRIEVED_USERS';
export const ERROR_RETRIEVING_USERS = 'USERS.ERROR_RETRIEVING_USERS';

export const retrieveCompanies = (queryObject = {}) => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const query = Object.keys(queryObject).map(key => `${key}=${queryObject[key]}`).join('&');
    const companies = await getCompanies(query);
    dispatch({
      type: RETRIEVED_COMPANIES,
      companies: companies.companies,
      total: companies.total,
    });
    dispatch({ type: LOADED });
  } catch (error) {
    dispatch({ type: ERROR_RETRIEVING_COMPANIES, error });
    dispatch({ type: LOADED });
  }
};

export const fetchCompanies = () => async (dispatch) => {
  try {
    const companies = await getCompanies();

    dispatch({ type: FETCH_COMPANIES, companies });
  } catch (error) {
    dispatch({ type: ERROR_RETRIEVING_COMPANIES, error });
  }
};

export const retrieveUserPending = () => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const response = await getUsersPending();
    dispatch({ type: RETRIEVED_USERS, users: response });
    dispatch({ type: LOADED });
  } catch (error) {
    console.log('Failed to retrieve users: ', error);
    dispatch({ type: ERROR_RETRIEVING_USERS, error });
  }
};

export const enableUser = token => async (dispatch) => {
  console.log('using token', token);
  try {
    await activateUser(token);
    dispatch(retrieveUserPending());
    dispatch({
      type: SUCCESS,
      message: ['save-success', 'Changes'],
    });
  } catch (error) {
    console.log('Failed to retrieve users: ', error);
    dispatch({ type: ERROR_RETRIEVING_USERS, error });
  }
};
